import React from 'react';
import styles from './SelectBox.module.scss';
import cx from 'classnames';
const SelectBox = ({ value, onChange, singleNumber = false, checked, name, title, rounded = false, multiSelect = false, }) => (<span className={cx(styles.container, singleNumber && styles.singleNumber, rounded && styles.rounded)}>
    <label>
      <input name={name} type='checkbox' value={value} onChange={onChange} className={styles.hiddenInput} checked={checked}/>
      <span className={styles.indicator}>
        {title || value}
        {multiSelect && <span className={styles.close}/>}
      </span>
    </label>
  </span>);
export default SelectBox;
